import { setExaminerReportData, setExaminerReportModal } from '../../../../../store/workspace/slice';
import { selectExaminerReportData } from '../../../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../../../store/store';
import { MessageSquareIcon } from '../../../../../assets/icons';
import Modal from '../../../../../components/Modal';
import { useEffect } from 'react';
import styles from './style.module.scss';

export default function ExaminerReport() {
    const dispatch = useDispatch();
    const reportData = useSelector(selectExaminerReportData);

    const closeModal = () => dispatch(setExaminerReportModal(false));

    useEffect(() => {
        return () => {
            dispatch(setExaminerReportData(null));
        };
    }, [dispatch]);

    return (
        <Modal
            size='xxl'
            actions='dismiss'
            restrictActionsWidth
            closeFunc={closeModal}
            icon={<MessageSquareIcon />}
            childClassName={styles.wrapper}
            title={`Report - ${reportData?.fullName}`}
            dismissButton={{
                text: 'Close',
                type: 'Outline-Dark',
                onClick: closeModal,
            }}
        >
            <div className={styles.status}>
                <span>Multiple choice exam report</span>
            </div>
            <p className={styles.report}>{reportData?.report}</p>
        </Modal>
    );
};
